import React from 'react'
import { components } from 'react-select'

const thumbnailSrc = (data) => data?.coverPhoto?.url || data?.videoThumbnail

const OptionContent = ({ data }) => {
  const src = thumbnailSrc(data)

  return (
    <div className='structure-option'>
      {src ? (
        <img
          src={src}
          alt=''
          onError={(event) => {
            event.currentTarget.style.display = 'none'
          }}
        />
      ) : null}
      <span className='structure-option-title'>{data.title}</span>
    </div>
  )
}

export const CustomOption = (props) => (
  <components.Option {...props}>
    <OptionContent data={props.data} />
  </components.Option>
)

export const CustomSingleValue = (props) => (
  <components.SingleValue {...props}>
    <OptionContent data={props.data} />
  </components.SingleValue>
)
